export default __webpack_public_path__ + "static/media/blue_marker_linear_sci2_spritesheet.ab420397.png";